import { Routes, Route } from 'react-router-dom';

import { routes, BaseRoute } from '../config';
import { Navigate } from 'routes/Navigate';

import { CustomRoute } from './Route';

import { routeComponents } from './routeToComponent';

type RouteEntries = Array<[string, BaseRoute]>;

const entries = Object.entries(routes) as RouteEntries;

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      {entries.map(([routeName, { path, isOpen, ...config }]) => (
        <Route
          key={routeName}
          path={path}
          element={
            <CustomRoute
              isPrivate={!isOpen}
              {...config}
              component={routeComponents[routeName as keyof typeof routeComponents]}
            />
          }
        />
      ))}

      <Route
        path="*"
        element={<CustomRoute isPrivate component={() => <Navigate to="home" />} />}
      />
    </Routes>
  );
}
